import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api, fileUrl } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { ArrowLeft, Calendar, Loader2, Megaphone } from "lucide-react";
import RichText from "@/components/RichText";

export default function AnnouncementDetail() {
  const { id } = useParams();
  const [a, setA] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    setA(null); setNotFound(false);
    api.get(`/announcements/${id}`).then((r) => setA(r.data)).catch(() => setNotFound(true));
  }, [id]);

  if (notFound) {
    return (
      <div className="mx-auto max-w-3xl px-4 pb-32 pt-[140px] text-center sm:px-6">
        <h1 className="font-display text-3xl font-bold text-ztk-navy dark:text-white">Nie znaleziono ogłoszenia</h1>
        <Button asChild className="mt-6 bg-ztk-blue"><Link to="/">Wróć na stronę główną</Link></Button>
      </div>
    );
  }
  if (!a) {
    return <div className="flex min-h-[60vh] items-center justify-center pt-[68px]"><Loader2 className="h-8 w-8 animate-spin text-ztk-blue" /></div>;
  }

  return (
    <div className="pt-[68px]" data-testid="announcement-detail">
      <section className="relative overflow-hidden bg-ztk-navydark text-white">
        {a.image && (
          <div className="absolute inset-0">
            <img src={fileUrl(a.image)} alt="" className="h-full w-full object-cover opacity-25" />
            <div className="absolute inset-0 bg-gradient-to-t from-ztk-navydark via-ztk-navydark/85 to-ztk-navydark/50" />
          </div>
        )}
        <div className="hero-grid absolute inset-0 opacity-30" />
        <div className="relative mx-auto max-w-4xl px-4 py-16 sm:px-6 lg:px-8 lg:py-20">
          <Button asChild variant="ghost" size="sm" className="mb-6 gap-1.5 text-slate-300 hover:text-white" data-testid="announcement-back">
            <Link to="/"><ArrowLeft className="h-4 w-4" /> Strona główna</Link>
          </Button>
          <p className="label-mono flex items-center gap-2 text-ztk-glow"><Megaphone className="h-4 w-4" /> Aktualność</p>
          <h1 className="mt-3 font-display text-3xl font-extrabold leading-tight tracking-tight sm:text-4xl lg:text-5xl" data-testid="announcement-title">{a.title}</h1>
          <p className="mt-4 flex items-center gap-2 text-sm text-slate-300"><Calendar className="h-4 w-4 text-ztk-glow" />{new Date(a.created_at).toLocaleDateString("pl-PL", { year: "numeric", month: "long", day: "numeric" })}</p>
        </div>
        <div className="cable-accent h-[3px] w-full" />
      </section>
      <section className="mx-auto max-w-4xl px-4 py-14 sm:px-6 lg:px-8">
        {a.image && <img src={fileUrl(a.image)} alt={a.title} className="mb-8 max-h-[420px] w-full rounded-2xl border border-border object-cover" />}
        <RichText html={a.body} className="prose-ztk text-muted-foreground" />
      </section>
    </div>
  );
}
